import clsx from 'clsx';
import type * as React from 'react';

export type WireframeBarProps = React.ComponentPropsWithoutRef<'span'>;

/**
 * Note: ONLY intended for empty-state illustrations.
 *
 * Tinted rectangular bar standing in for a line of variable text content
 * inside a mid-fidelity empty-state illustration. Always pass an explicit
 * `h-*` and `w-*` (and optional `opacity-*`) through `className` — there is
 * no default height because Tailwind utility ordering would make a default
 * conflict unpredictably with overrides.
 *
 * Renders a block-level `<span>` so it remains valid markup inside both
 * `<div>` and `<span>` parents while still respecting width/height utilities.
 */
export function WireframeBar(props: WireframeBarProps) {
    const { className, ...rest } = props;
    const hasBackground = /\bbg-/.test(className ?? '');
    return (
        <span
            aria-hidden
            {...rest}
            className={clsx('block rounded-sm', !hasBackground && 'bg-neutral-ui', className)}
        />
    );
}
